import classNames from 'classnames';

const publicUrl = process.env.PUBLIC_URL || '';
const LOGO_FULL = `${publicUrl}/SafeMeet.ir.svg`;
const LOGO_MARK = `${publicUrl}/SafeMeet-mark.svg`;

const SIZES = {
  sm: { fullHeight: 32, mark: 32 },
  md: { fullHeight: 40, mark: 36 },
  lg: { fullHeight: 48, mark: 44 },
};

/**
 * لوگوی برند SafeMeet.ir — SVG شفاف؛ نسخه کامل یا آیکون فشرده.
 */
const Logo = ({ collapsed = false, className, size = 'md', light = false }) => {
  const { fullHeight, mark } = SIZES[size] || SIZES.md;
  const showMark = collapsed || light;

  if (showMark) {
    return (
      <div
        className={classNames(
          'flex items-center justify-center',
          light && 'rounded-xl border border-white/20 bg-white/95 p-1.5 shadow-sm backdrop-blur-sm',
          className,
        )}
      >
        <img
          src={LOGO_MARK}
          alt="SafeMeet.ir"
          width={mark}
          height={mark}
          className="block object-contain"
          style={{ width: mark, height: mark }}
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div dir="ltr" className={classNames('flex items-center justify-start', className)}>
      <img
        src={LOGO_FULL}
        alt="SafeMeet.ir"
        className="block max-w-full object-contain object-left dark:brightness-110 dark:contrast-105"
        style={{ height: fullHeight, maxWidth: 220 }}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
